export class AuthorizationSystem {
    sourceSystemId = '';
    sourceSystemName = '';
    integrationMethod = '';
    active = true;
    restApiBaseUrl = '';
    graphQL = false;
    authenticationType = '';
    authorizationKey = '';
    additionalHeaders: {} = {};
    grantType = '';
    userName = '';
    password = '';
    customAuthenticationInfo = '';
    accessTokenUrl = '';
    clientId = '';
    clientSecret = '';
    scope = '';
    clientAuthentication = '';
    authorizationUrl = '';
    callbackUrl = '';
    refreshTokenUrl = '';
    oauthUserName = '';
    oauthPassword = '';
    sslEnabled = false;
    encryptionEnabled = false;
    sslCertificates: {} = {};
    encryptionKeyFile: {} = {};
    createdBy = '';
    createdOn = '';
    updatedBy = '';
    updatedOn = '';
}
